import { getTempId } from "@/core/utils/utils";
import { Declaration } from "@/apps/shared/buyback/core/domain/model/declaration/Declaration";
import { BuybackInCart } from "@/apps/shared/buyback/core/domain/model/buybackInCart/BuybackInCart";
import { DispatchCircuitRule, DispatchCircuitRuleAdapter } from "@/core/models/dispatchCircuitRule";
import { CheckoutMethodsMapper } from "@/apps/shared/proposal/core/domain/mapper/checkoutMethodsMapper";
import { BuybackForm } from "@/apps/shared/buyback/view/forms/buybackForm";
import { ImpactPriceEntry } from "@/apps/shared/proposal/core/infrastructure/legacy/ImpactPriceEntry";
import { Product as ProductLegacy } from "@/core/models/product";
import { Product } from "@/apps/shared/buyback/core/domain/model/declaration/Product";
import { Category } from "@/apps/shared/buyback/core/domain/model/declaration/Category";
import { Response } from "@/apps/shared/buyback/core/domain/model/declaration/Response";
import { PaymentMethod } from "@/apps/shared/proposal/core/domain/model/PaymentMethod";
import { ShippingMethod } from "@/apps/shared/proposal/core/domain/model/ShippingMethod";

class BuybackInCartBuilder {
  buildProduct(selectedProduct: ProductLegacy): Product {
    const category: Category = {
      id: selectedProduct.category.id,
      label: selectedProduct.category.label,
    };

    return {
      id: selectedProduct.id,
      label: selectedProduct.label,
      brand: selectedProduct.brand,
      modele: selectedProduct.modele,
      eanCode: selectedProduct.eanCode,
      reference: selectedProduct.reference,
      image: selectedProduct.image,
      category: category,
    };
  }

  buildDeclaration(
    declarationId: string | null,
    selectedProduct: ProductLegacy,
    selectedResponses: Array<Response>,
    grade: string,
    imei: string | null
  ): Declaration {
    const product: Product = this.buildProduct(selectedProduct);

    return {
      id: declarationId,
      responses: selectedResponses,
      product: product,
      grade: grade,
      imei: imei,
    };
  }

  buildBuybackInCart(
    declaration: Declaration,
    estimatedPrice: number,
    transportMode: DispatchCircuitRule,
    shippingMethod: ShippingMethod,
    paymentMethod: PaymentMethod,
    totalPrice: number,
    impactPriceEntries: ImpactPriceEntry[]
  ): BuybackInCart {
    return new BuybackInCart(
      getTempId(),
      estimatedPrice,
      transportMode,
      shippingMethod,
      paymentMethod,
      totalPrice,
      impactPriceEntries,
      null,
      declaration
    );
  }

  buildFromBuybackForm(
    buybackForm: BuybackForm,
    totalPrice: number,
    impactPriceEntries: ImpactPriceEntry[]
  ): BuybackInCart {
    const product: Product = this.buildProduct(buybackForm.selectedProduct);

    const declaration: Declaration = {
      id: buybackForm.declarationId,
      responses: buybackForm.selectedResponses,
      product: product,
      grade: buybackForm.grade,
      imei: buybackForm.imei,
    };

    return new BuybackInCart(
      buybackForm.inCartId,
      buybackForm.getEstimatedPrice(),
      buybackForm.buybackOptions.getTransportMode()!,
      buybackForm.buybackOptions.getShippingMethod(),
      buybackForm.buybackOptions.getPaymentMode(),
      totalPrice,
      impactPriceEntries,
      null,
      declaration
    );
  }

  buildFromParsedCartBuyback(parsedBuybackInCart: any): BuybackInCart {
    return new BuybackInCart(
      parsedBuybackInCart.inCartId,
      parsedBuybackInCart.estimatedPrice,
      DispatchCircuitRuleAdapter.adapt(parsedBuybackInCart.transportMode),
      CheckoutMethodsMapper.mapCartShippingMethod(parsedBuybackInCart.shippingMethod),
      CheckoutMethodsMapper.mapCartPaymentMethod(parsedBuybackInCart.paymentMode),
      parsedBuybackInCart.totalPrice,
      parsedBuybackInCart.impactPriceEntries,
      parsedBuybackInCart.warehouseId,
      parsedBuybackInCart.declaration
    );
  }
}

export default new BuybackInCartBuilder();
